export default __webpack_public_path__ + "static/media/21.74826f07.webp";